(function () {
  'use strict';
  if (window.BBContactForm) { window.BBContactForm.init(document); return; }
  var handlerPromise;
  var backgroundReady = false;
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) { observer.unobserve(entry.target); load(entry.target); }
    });
  }, { rootMargin: '1800px 0px' }) : null;

  function handler() {
    if (window.jotformEmbedHandler) return Promise.resolve();
    if (!handlerPromise) {
      handlerPromise = new Promise(function(resolve, reject) {
        var script = document.createElement('script');
        script.src = 'https://choose2rent.jotform.com/s/umd/latest/for-form-embed-handler.js';
        script.onload = resolve;
        script.onerror = function() { handlerPromise = null; script.remove(); reject(new Error('Form resize handler unavailable')); };
        document.head.appendChild(script);
      });
    }
    return handlerPromise;
  }

  function load(container) {
    if (!container.isConnected || container.dataset.bbContactLoaded) return;
    var template = container.querySelector('template');
    if (!template) return;
    if (observer) observer.unobserve(container);
    container.dataset.bbContactLoaded = 'true';
    container.appendChild(template.content.cloneNode(true));
    template.remove();
    var frame = container.querySelector('iframe');
    if (!frame) return;
    handler().then(function() {
      if (frame.isConnected && window.jotformEmbedHandler) {
        window.jotformEmbedHandler("iframe[id='" + frame.id + "']", 'https://choose2rent.jotform.com/');
      }
    }).catch(function() { /* The form itself remains available without the resize helper. */ });
  }

  function init(scope) {
    var containers = Array.from(scope.querySelectorAll('[data-bb-contact-embed]'));
    if (scope.matches && scope.matches('[data-bb-contact-embed]')) containers.unshift(scope);
    containers.forEach(function(container) {
      if (backgroundReady) { load(container); return; }
      if (container.dataset.bbContactObserved) return;
      container.dataset.bbContactObserved = 'true';
      if (!observer || (window.Shopify && window.Shopify.designMode)) load(container);
      else observer.observe(container);
    });
  }
  window.BBContactForm = { init: init };
  init(document);
  function warmForms() {
    window.setTimeout(function() {
      backgroundReady = true;
      init(document);
    }, 2000);
  }
  if (document.readyState === 'complete') warmForms();
  else window.addEventListener('load', warmForms, { once: true });
  document.addEventListener('shopify:section:load', function(event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function(event) {
    if (observer) event.target.querySelectorAll('[data-bb-contact-embed]').forEach(function(container) { observer.unobserve(container); });
  });
})();
